import { ReactNode } from "react";
import { Row, Col, Image } from "react-bootstrap";

interface Props {
  children: ReactNode;
  title: string;
  textLeft: boolean;
  media?: ReactNode;
  style?: React.CSSProperties;
}

export const FeaturesRow: React.FC<Props> = ({
  children,
  title,
  textLeft = true,
  media,
  style,
}) => {
  return (
    <Row
    data-aos={textLeft ? "fade-right" : "fade-left"}
      className="align-items-center py-5 my-5 px-3 rounded shadow-sm"
      style={{
        background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
        ...style,
      }}
    >
      <Col
        xs={{ span: 12, order: textLeft ? 0 : 1 }}
        lg={{ span: 5, order: textLeft ? 0 : 1, offset: textLeft ? 1 : 0 }}
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <h2 className="fw-bold text-center text-md-start mb-4">{title}</h2>
        <div
          style={{
            textAlign: "justify",
            lineHeight: "1.7",
          }}
        >
          {children}
        </div>
      </Col>

      <Col
        xs={{ span: 12, order: textLeft ? 1 : 0 }}
        lg={{ span: 5, order: textLeft ? 1 : 0, offset: textLeft ? 0 : 1 }}
        className="d-flex justify-content-center"
      >
        <div
          style={{
            width: "100%",
            maxHeight: "420px",
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          {media}
        </div>
      </Col>
    </Row>
  );
};


// <div
// style={{
//   borderTop: "2px solid black" /* Define the border style */,
//   margin: "10px 0" /* Adjust margin as needed */,
//   width: "80%" /* Make it full width */
// }}/>